
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import GlobalContext from '@/contexts/GlobalContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { Layout } from '@/components/Layout';
import { RouteGuard } from '@/components/RouteGuard';
import { ApiDebug } from '@/components/ApiDebug';
import { Leaderboard } from '@/pages/Leaderboard';
import { Profile } from '@/pages/Profile';
import { Community } from '@/pages/Community';
import { Members } from '@/pages/Members';
import { ChessSetup } from '@/pages/ChessSetup';
import './index.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalContext>
        <AuthProvider>
          <Router>
            <RouteGuard>
              <Layout>
                <Routes>
                  <Route path="/" element={<Leaderboard />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/members" element={<Members />} />
                  <Route path="/chess-setup" element={<ChessSetup />} />
                  <Route path="/debug" element={<ApiDebug />} />
                </Routes>
              </Layout>
            </RouteGuard>
          </Router>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </AuthProvider>
      </GlobalContext>
    </QueryClientProvider>
  );
}

export default App; 